// Angular
import { Component, Input, OnInit } from '@angular/core';
// Layout
import { LayoutConfigService, ToggleOptions } from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';
import { ActivatedRoute } from '@angular/router';
import { FilteredViewService } from '../../../core/services/filtered-view.service';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'kt-brand',
  templateUrl: './brand.component.html',
})
export class BrandComponent implements OnInit {
  // Public properties
  headerLogo = null;
  brandClasses = '';
  minimized: boolean;
  asideSelfMinimizeToggle = true;
  filterView: boolean;

  @Input() viewLogoFun;

  toggleOptions: ToggleOptions = {
    target: 'kt_body',
    targetState: 'aside-minimize',
    toggleState: 'active',
  };

  /**
   * Component constructor
   *
   * @param layoutConfigService: LayoutConfigService
   * @param htmlClassService: HtmlClassService
   */
  constructor(
    private filteredViewService: FilteredViewService,
    private layoutConfigService: LayoutConfigService,
    public htmlClassService: HtmlClassService,
    private router: ActivatedRoute,
    public themeService: ThemeService,
  ) {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit(): void {
    this.headerLogo = this.getAsideLogo();
    this.brandClasses = this.htmlClassService.getClasses('brand', true).toString();
    this.asideSelfMinimizeToggle = this.layoutConfigService.getConfig('aside.self.minimize.toggle');
    this.filteredViewService.isFilterView.subscribe((value) => {
      this.filterView = value;
    });
  }

  getAsideLogo() {
    return `./assets/media/logos/aplosLogo.png`;
  }
}
